export const timeouts = {
  critical: 120000,
  noncritical: 4000,
};
